
  import Vue from 'vue'
  // 自定义指令 文档title
  Vue.directive('title', {
    inserted: function (el, binding) {
      document.title = el.dataset.title
    },
    update: function (el, binding) {
      document.title = el.dataset.title
    }
  })
  //v-fous
  Vue.directive('focus',
    {
      //使用v-if,此处应写到inserted方法里
      inserted: function (el, option) {
        var defClass = 'el-input', defTag = 'input';
        var value = option.value || true;
//    if (typeof value === 'boolean'){
//      value = { cls: defClass, tag: defTag, foc: value };
//    }else{
        value = {cls: value.cls || defClass, tag: value.tag || defTag, foc: value.foc || false};
//    }
        if (el.classList.contains(value.cls) && value.foc) {
          el.getElementsByTagName(value.tag)[0].focus();
        }
      }
    }
  );
  //自定义指令 鼠标悬停显示 title提示
  Vue.directive('ellipses', {
    inserted: function (el, binding) {
      el.title = el.innerText;
    }
  })
  // 自定义指令 超出字符 显示省略号
  Vue.directive('maxNum', {

    inserted: function (el, binding) {
      let numstr = el.innerText;
      let numlength = numstr.length;
      let end = binding.value.end;
      let start = binding.value.start;
      if (numlength > (end - start)) {
        let test;
        let num = 0;

        for (let i = 0; i < end; i++) {
          if (numstr.charCodeAt(i) >= 0 && numstr.charCodeAt(i) <= 128) {
            num++;
          }
        }
        test = numstr.split('').slice(start, (end + num / 2)).join('');
        el.innerText = test + '...';
        // 显示全称
        el.title = numstr
        return el.innerText

      } else {
        return numstr
      }
    },
    update: function (newValue, oldValue, el, binding) {

    }

  })
  // 拖拽 涂鸦板
  Vue.directive('drag-tuya', function (el) {
    var oDiv = el;
    oDiv.onmousedown = function (ev) {
      var disX = ev.clientX - oDiv.offsetLeft;
      var clientWidth = document.body.clientWidth;
      var disY = ev.clientY - oDiv.offsetTop;
      var clientHeight = document.body.clientHeight;

      document.onmousemove = function (ev) {
        var w = ev.clientX - disX;
        var h = ev.clientY - disY
        // width
        if (w < -5) {
          w = 0
        }
        if (w > clientWidth - 55) {
          w = clientWidth - 60;
        }
        // height
        if (h < -5) {
          h = 0;
        }
        if (h > clientHeight - 55) {
          h = clientHeight - 60;
        }

        oDiv.style.left = w + 'px';
        oDiv.style.top = h + 'px';
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  });

  // 拖拽 专业题盖章
  Vue.directive('drag-stamp', function (el) {
    var stamp = el;

    stamp.onmousedown = function (ev) {
      //stamp父层
      var stampParent = stamp.offsetParent;

      var disX = ev.clientX - stamp.offsetLeft;
      var clientWidth = document.body.clientWidth;
      var disY = ev.clientY - stamp.offsetTop;
      var clientHeight = document.body.clientHeight;
      //网页可见区域宽+包括边线的宽+(Height+padding+border)
//      var offsetWidth = document.body.offsetWidth;
//      var offsetHeight = document.body.offsetHeight;
//
//      var  scrollWidth = document.body.scrollWidth;
//      var  scrollHeight = document.body.scrollHeight;
//
//      var scrollTop = document.body.scrollTop;
//      var scrollLeft = document.body.scrollLeft;

//      console.log('网页可见区域宽' + clientWidth);
//      console.log('网页可见区域高' + clientHeight);
//
//      console.log('网页可见区域宽+包括边线的宽+(Width+padding+border)' + offsetWidth);
//      console.log('网页可见区域高+包括边线的高+(Height+padding+border)' + offsetHeight);
//
//      console.log('网页正文全文宽' + scrollWidth);
//      console.log('网页正文全文高' + scrollHeight);
//
//      console.log('网页被卷去的高' + scrollTop);
//      console.log('网页被卷去的左' + scrollLeft);

      //获取章的大小
//      console.log(stamp.clientWidth);
//      console.log(stamp.clientHeight);
//
//      console.log(stamp.offsetWidth);
//      console.log(stamp.offsetHeight);
//
//      console.log('father');
//      console.log(stampParent)
//      console.log(stampParent.offsetWidth);
//      console.log(stampParent.offsetHeight);
//      console.log("offsetTop 不知道干什么的");
//      console.log(stampParent.offsetTop);
//      console.log(stampParent.offsetLeft);
//
//      console.log('child');
//      var sl = ev.clientX - stamp.offsetLeft;
//      var st = ev.clientY -stamp.offsetTop;
//      console.log(ev.offsetX);
//      console.log(ev.offsetY);
//      console.log(111111111111111);
//      console.log(sl);
//      console.log(st);


      document.onmousemove = function (ev) {
        var w = ev.clientX - disX;
        var h = ev.clientY - disY
        // width
        if (w < -5) {
          w = 0
        }
        if (w > stampParent.clientWidth - 55) {
          w = stampParent.clientWidth - 55;
        }
        // height
        if (h < -5) {
          h = 0;
        }
        if (h > stampParent.clientHeight - 25) {
          h = stampParent.clientHeight - 25;
        }
        stamp.style.left = w + 'px';
        stamp.style.top = h + 'px';
        stamp.style.width = stamp.offsetWidth + 'px';
        stamp.style.height = stamp.offsetHeight + 'px';
        //最后保存的数据
        //console.log(w);
        //console.log(h);
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  });

  // 拖拽 涂鸦板
  Vue.directive('drag-ppt', function (el) {
    var oDiv = el;
    oDiv.onmousedown = function (ev) {
      var disX = ev.clientX - oDiv.offsetLeft;
      var clientWidth = document.body.clientWidth;
      var disY = ev.clientY - oDiv.offsetTop;
      var clientHeight = document.body.clientHeight;

      document.onmousemove = function (ev) {
        var w = ev.clientX - disX;
        var h = ev.clientY - disY
        // width
        if (w < -5) {
          w = 0
        }
        if (w > clientWidth - 55) {
          w = clientWidth - 60;
        }
        // height
        if (h < -5) {
          h = 0;
        }
        if (h > clientHeight - 55) {
          h = clientHeight - 60;
        }

        oDiv.style.left = w + 'px';
        oDiv.style.top = h + 'px';
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  });




// WEBPACK FOOTER //
// ./src/components/common/Directive.vue